import { render, staticRenderFns } from "./common-official-document-error.view.vue?vue&type=template&id=346d0070&"
import script from "./common-official-document-error.view.vue?vue&type=script&lang=ts&"
export * from "./common-official-document-error.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports